<template>
  <v-theme-provider :dark="dark">
    <div>
      <!--
      <base-img
        :src="require('@/assets/zero-logo-dark.svg')"
        contain
        max-width="128"
        min-height="78"
        width="100%"
      />
      -->
      <base-title
        size="body-1"
        space="4"
        title="Tarantula: DB Gateway"
        weight="regular"
      />

      <base-body>
        타란툴라는 일종의 스위스 나이프 칼 같은 솔루션입니다.
        <br>데이터베이스를 사용하는 어느 환경에서나 훌륭한 제 몫을 해 낼것을 자신합니다.
      </base-body>

      <!--
      <base-btn
        class="mb-12"
        color="white"
        outlined
      >
        More Info
      </base-btn>
      -->
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '01 (800) 433 744<br>01 (800) 433 633',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'john@vuetifyjs.com<br>heather@vuetifyjs.com',
        },
      ],
    }),
  }
</script>
